import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { rootRoute } from './root'
import { RouteError } from '@lunary/ui-web/screen-state'

export const authRoute = createRoute({
  path: 'auth',
  getParentRoute: () => rootRoute,
  component: lazyRouteComponent(() => import('../features/auth/page'), 'AuthPage'),
  errorComponent: RouteError,
})
